/*
 * @Author: Teemo Ding
 * @Date: 2021-10-25 17:15:19
 * @LastEditTime: 2022-06-01 16:21:20
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/WarehouseLocations/ParcelLocker/index.tsx
 */
import { Button, SizeFittingTable } from '@/src/components/Antd';
import {
  deleteParcelLocker,
  getParcelLockersList,
} from '@/src/request/settings/logistics/parcelLocker';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from '@/src/types/common/resources';
import { useRequest } from 'ahooks';
import { Spin, message } from 'antd';
import React from 'react';
import { useHistory } from 'react-router';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';

const permissions = () => {
  const add_edit_courier_account_parcel_locker_delivery_method = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsLogisticsWarehouse,
        operation:
          EnumOperation.add_edit_courier_account_parcel_locker_delivery_method,
      }),
    ],
  });
  return {
    add_edit_courier_account_parcel_locker_delivery_method,
  };
};

const ParcelLocker = ({ warehouseUuid }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { add_edit_courier_account_parcel_locker_delivery_method } =
    permissions();
  const history = useHistory();
  const {
    loading: parcelLockerLoading,
    data: parcelLockers,
    run: runParcelLockers,
  } = useRequest(() => getParcelLockersList(warehouseUuid));

  const { loading: deleteLoading, run: _deleteParcelLocker } = useRequest(
    (uuid) => deleteParcelLocker(uuid),
    {
      manual: true,
      onSuccess(result) {
        message.success(getI18n('general.deletedsuccessfully'));
        runParcelLockers();
      },
    },
  );

  const onAddClick = () => {
    history.push(`/settings/logistics/parcelLocker/setting/${warehouseUuid}/`);
  };

  const onEdit = (uuid) => {
    history.push(
      `/settings/logistics/parcelLocker/setting/${warehouseUuid}/${uuid}`,
    );
  };

  const onDelete = (uuid) => {
    _deleteParcelLocker(uuid);
  };

  const columns = [
    {
      title: getI18n('storeLogistics.warehouseLocations.parcelLocker'),
      dataIndex: 'name',
      default: true,
      key: 'name',
      minWidth: 320,
    },
    {
      title: getI18n('storeLogistics.warehouseLocations.courierAccount'),
      dataIndex: ['courierAccount', 'name'],
      default: true,
      key: 'courierAccountName',
      minWidth: 640,
    },
    {
      title: getI18n(
        'general.advancedFilters.commonStoreProductsWithTable.actions',
      ),
      dataIndex: 'action',
      default: true,
      key: 'action',
      minWidth: 128,
      childGenerate: (text, record, index) =>
        add_edit_courier_account_parcel_locker_delivery_method ? (
          <div className={css.action}>
            <span className={css.danger} onClick={() => onDelete(record.uuid)}>
              {getI18n('general.delete')}
            </span>
            <span className={css.primary} onClick={() => onEdit(record.uuid)}>
              {getI18n('general.edit')}
            </span>
          </div>
        ) : null,
    },
  ];

  return (
    <div>
      <Spin spinning={parcelLockerLoading || deleteLoading}>
        <SizeFittingTable
          id='ShippingZoneTable'
          rowKey='uuid'
          pagination={false}
          dataSource={parcelLockers}
          className={css.shippingZoneTable}
          columns={columns}
          rowClassName={css.row}
        />
        <Button
          type='primary'
          className={css.button}
          onClick={onAddClick}
          disabled={!add_edit_courier_account_parcel_locker_delivery_method}>
          {getI18n('storeLogistics.warehouseLocations.addParcelLocker')}
        </Button>
      </Spin>
    </div>
  );
};

export default ParcelLocker;
